
export enum PricingType {
  Knitting = 0,
  Finishing = 1,
  FireTesting = 2
}

export const pricingTypes = [
  {label: 'Knitting', value: PricingType.Knitting},
  {label: 'Finishing', value: PricingType.Finishing},
  {label: 'Fire Testing', value: PricingType.FireTesting}
]